export const Button = ({onClick, disabled, children}) => {
    return <button type='submit'
                   className={`btn ${disabled ? "" : "primary"}`}
                   onClick={onClick}>
        {children}
    </button>
}